import * as Yup from "yup";

const emailPersonalizadoValidator = Yup.object().shape({
  contexto: Yup.string().nullable().required("Contexto"),
  assunto: Yup.string().nullable().required("Assunto"),
  mensagem: Yup.string().nullable().required("Mensagem"),
  variaveis: Yup.array().of(Yup.string()).nullable().optional(),
  ativado: Yup.boolean().nullable().optional(),
});

export default emailPersonalizadoValidator;
